import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from '../service/local-storage.service';
import { LocalStorageEnum } from '../../shared/enum.ts/local-storage.enum';
import { Role } from '../../shared/enum.ts/role.enum';

const ADMIN_ROLES: readonly Role[] = [Role.SUPER_ADMIN, Role.STORE_ADMIN];

/**
 * Allows users with `SUPER_ADMIN` or `STORE_ADMIN` roles (user/customer
 * management, not store-floor managers). For store + ledger routes use
 * {@link storeStaffGuard}.
 */
export const adminGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const user = localStorageService.getItem(LocalStorageEnum.USER) as { roleName?: string } | null;
  const role = user?.roleName as Role | undefined;
  return role != null && ADMIN_ROLES.includes(role);
};
